import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    SelectFilterModel,
} from '@ui/shared/util-filter';
import { CultureExperienceTypeOrderingEnum, CultureMapService } from '@ui/shared/util-api';
import { CultureMapFilterKey } from '../../enums/culture-map-filter-key';
import { toDataResult, ToResult } from '@team23/ts-result';

@Injectable({ providedIn: 'root' })
export class ExperienceTypeSelectFilterConfigService extends FilterConfigService<CultureMapFilterKey, CultureMapService> {

    constructor() {
        super(
            new SelectFilterModel(CultureMapFilterKey.ExperienceType, 'Erlebnis', []),
            inject(CultureMapService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllCultureExperienceTypes({
            order: [CultureExperienceTypeOrderingEnum.Id],
        })
            .pipe(
                map(result =>
                    result.data
                        .map(dto => ({
                            value: dto.id,
                            label: dto.name,
                        })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
